export const calculateTotalItem = items => {
    return items.map(item => {
        const totalPrice = calculateTotalPrice(item)

        return { ...item, totalPrice }
    })
}

export const calculateTotalInvoice = (items, ivaPercent) => {
    ivaPercent = ivaPercent && !isNaN(ivaPercent) ? ivaPercent : 21
    ivaPercent = parseFloat(ivaPercent) / 100
    let [ivaPrice, base, total] = [0, 0, 0]

    items.forEach(item => {
        const totalPrice = calculateTotalPrice(item)
        let ivaPriceItem = 0
        let basePriceItem = 0

        if (item.iva) {
            basePriceItem = calculateWithIVA(totalPrice, ivaPercent)
            ivaPriceItem = totalPrice - basePriceItem
        } else {
            ivaPriceItem = totalPrice * ivaPercent
            basePriceItem = totalPrice
        }

        ivaPrice += ivaPriceItem
        base += basePriceItem
        total += ivaPriceItem + basePriceItem
    })
    
    return { 
        ivaPrice: parseFloat(ivaPrice.toFixed(2)), 
        base: parseFloat(base.toFixed(2)), 
        total: parseFloat(total.toFixed(2)) 
    }
}

const calculateWithIVA = (totalPrice, ivaPercent) => {
    const result = totalPrice / (1 + ivaPercent)
    return parseFloat(result.toFixed(2))
}

export const calculateTotalPrice = item => {
    let { units, unitPrice } = item
    units = parseInt(units || 0)
    unitPrice = parseFloat(unitPrice || 0)
    const mult = units * unitPrice
    return parseFloat(mult.toFixed(2))
}